export const INITIAL_MEMBERS_PAGE_MODEL = {
    showOrganizationFilter: true,
    backgroundUrl: '',
    backgroundFixed: true,
    showTitle: true,
    titleRu: 'Участники',
    titleEn: 'Members',
    showSubstrate: true,
    showBigPhotos: false,
    showPhotoCentered: false,
};
